export const actionTypes = {
  GET_MOBILE_USER_LIST_PENDING: "GET_MOBILE_USER_LIST_PENDING",
  GET_MOBILE_USER_LIST_SUCCESS: "GET_MOBILE_USER_LIST_SUCCESS",
  GET_MOBILE_USER_LIST_ERROR: "GET_MOBILE_USER_LIST_ERROR",

  GET_MOBILE_USER_BY_ID_PENDING: "GET_MOBILE_USER_BY_ID_PENDING",
  GET_MOBILE_USER_BY_ID_SUCCESS: "GET_MOBILE_USER_BY_ID_SUCCESS",
  GET_MOBILE_USER_BY_ID_ERROR: "GET_MOBILE_USER_BY_ID_ERROR",

  VIEW_USER_PENDING: "VIEW_USER_PENDING",
  VIEW_USER_SUCCESS: "VIEW_USER_SUCCESS",
  VIEW_USER_ERROR: "VIEW_USER_ERROR",

  ADD_NEW_USER_PENDING: "ADD_NEW_USER_PENDING",
  ADD_NEW_USER_SUCCESS: "ADD_NEW_USER_SUCCESS",
  ADD_NEW_USER_ERROR: "ADD_NEW_USER_ERROR",

  EDIT_USER_PENDING: "EDIT_USER_PENDING",
  EDIT_USER_SUCCESS: "EDIT_USER_SUCCESS",
  EDIT_USER_ERROR: "EDIT_USER_ERROR",

  DELETE_USER_PENDING: "DELETE_USER_PENDING",
  DELETE_USER_SUCCESS: "DELETE_USER_SUCCESS",
  DELETE_USER_ERROR: "DELETE_USER_ERROR",

  GET_MOBILE_USER_ACTIVITY_LOG_PENDING: "GET_MOBILE_USER_ACTIVITY_LOG_PENDING",
  GET_MOBILE_USER_ACTIVITY_LOG_SUCCESS: "GET_MOBILE_USER_ACTIVITY_LOG_SUCCESS",
  GET_MOBILE_USER_ACTIVITY_LOG_ERROR: "GET_MOBILE_USER_ACTIVITY_LOG_ERROR",

  GET_MOBILE_USER_ACTIVITY_LOG_BY_ID_PENDING:
    "GET_MOBILE_USER_ACTIVITY_LOG_BY_ID_PENDING",
  GET_MOBILE_USER_ACTIVITY_LOG_BY_ID_SUCCESS:
    "GET_MOBILE_USER_ACTIVITY_LOG_BY_ID_SUCCESS",
  GET_MOBILE_USER_ACTIVITY_LOG_BY_ID_ERROR:
    "GET_MOBILE_USER_ACTIVITY_LOG_BY_ID_ERROR",

  FORCE_LOGOUT_PENDING: "FORCE_LOGOUT_PENDING",
  FORCE_LOGOUT_SUCCESS: "FORCE_LOGOUT_SUCCESS",
  FORCE_LOGOUT_ERROR: "FORCE_LOGOUT_ERROR",

  UPDATE_CURRENT_PAGE: "UPDATE_CURRENT_PAGE",

  UPDATE_ROWS_PER_PAGE: "UPDATE_ROWS_PER_PAGE",

  UPDATE_SEARCH_FILTERS: "UPDATE_SEARCH_FILTERS",

  UPDATE_SEARCH_FILTERS_OF_USERS_SEND_NOTIFICATION:
    "UPDATE_SEARCH_FILTERS_OF_USERS_SEND_NOTIFICATION",

  UPDATE_CURRENT_PAGE_OF_USERS_ACTIVITY_LOG:
    "UPDATE_CURRENT_PAGE_OF_USERS_ACTIVITY_LOG",

  UPDATE_ROWS_PER_PAGE_OF_USERS_ACTIVITY_LOG:
    "UPDATE_ROWS_PER_PAGE_OF_USERS_ACTIVITY_LOG",

  UPDATE_CURRENT_PAGE_OF_USERS_SEND_NOTIFICATION:
    "UPDATE_CURRENT_PAGE_OF_USERS_SEND_NOTIFICATION",

  UPDATE_ROWS_PER_PAGE_OF_USERS_SEND_NOTIFICATION:
    "UPDATE_ROWS_PER_PAGE_OF_USERS_SEND_NOTIFICATION",
};

const initialState = {
  getMobileUserListPending: false,
  getMobileUserListSuccess: false,
  getMobileUserListError: null,

  getMobileUserLByIdPending: false,
  getMobileUserLByIdSuccess: false,
  getMobileUserByIdError: null,

  viewUserPending: false,
  viewUserSuccess: false,
  viewUserError: null,

  addNewUserPending: false,
  addNewUserSuccess: false,
  addNewUserError: null,

  editUserPending: false,
  editUserSuccess: false,
  editUserError: null,

  deleteUserPending: false,
  deleteUserSuccess: false,
  deleteUserError: null,

  getMobileUserActivityLogPending: false,
  getMobileUserActivityLogSuccess: false,
  getMobileUserActivityLogError: null,

  getMobileUserActivityLogByIdPending: false,
  getMobileUserActivityLogByIdSuccess: false,
  getMobileUserActivityLogByIdError: null,

  forceLogoutPending: false,
  forceLogoutSuccess: false,
  forceLogoutError: null,

  mobileUserList: [],
  mobileUserActivityLogs: [],
  mobileUserActivityLogById: {},
  mobileUserDataById: {},
  fields: {
    searchString: "",
    subscription: [],
  },
  fieldsForUsersSendNotification: {
    searchString: "",
    subscription: [],
  },
  currentPage: 1,
  rowsPerPage: { label: "10", value: 10 },
  currentPageOfUsersActivityLog: 1,
  rowsPerPageOfUsersActivityLog: { label: "10", value: 10 },
  currentPageOfUsersSendNotification: 1,
  rowsPerPageOfUsersSendNotification: { label: "10", value: 10 },
};

export default function mobileUserManagement(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.GET_MOBILE_USER_LIST_SUCCESS:
    case actionTypes.GET_MOBILE_USER_LIST_PENDING:
    case actionTypes.GET_MOBILE_USER_LIST_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.GET_MOBILE_USER_BY_ID_PENDING:
    case actionTypes.GET_MOBILE_USER_BY_ID_SUCCESS:
    case actionTypes.GET_MOBILE_USER_BY_ID_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.VIEW_USER_PENDING:
    case actionTypes.VIEW_USER_SUCCESS:
    case actionTypes.VIEW_USER_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.ADD_NEW_USER_PENDING:
    case actionTypes.ADD_NEW_USER_SUCCESS:
    case actionTypes.ADD_NEW_USER_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.EDIT_USER_PENDING:
    case actionTypes.EDIT_USER_SUCCESS:
    case actionTypes.EDIT_USER_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.DELETE_USER_PENDING:
    case actionTypes.DELETE_USER_SUCCESS:
    case actionTypes.DELETE_USER_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.GET_MOBILE_USER_ACTIVITY_LOG_PENDING:
    case actionTypes.GET_MOBILE_USER_ACTIVITY_LOG_SUCCESS:
    case actionTypes.GET_MOBILE_USER_ACTIVITY_LOG_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.GET_MOBILE_USER_ACTIVITY_LOG_BY_ID_PENDING:
    case actionTypes.GET_MOBILE_USER_ACTIVITY_LOG_BY_ID_SUCCESS:
    case actionTypes.GET_MOBILE_USER_ACTIVITY_LOG_BY_ID_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.FORCE_LOGOUT_PENDING:
    case actionTypes.FORCE_LOGOUT_SUCCESS:
    case actionTypes.FORCE_LOGOUT_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.UPDATE_ROWS_PER_PAGE:
      return Object.assign({}, state, payload);

    case actionTypes.UPDATE_CURRENT_PAGE:
      return Object.assign({}, state, payload);

    case actionTypes.UPDATE_SEARCH_FILTERS:
      return Object.assign({}, state, payload);

    case actionTypes.UPDATE_SEARCH_FILTERS_OF_USERS_SEND_NOTIFICATION:
      return Object.assign({}, state, payload);

    case actionTypes.UPDATE_CURRENT_PAGE_OF_USERS_ACTIVITY_LOG:
      return Object.assign({}, state, payload);

    case actionTypes.UPDATE_ROWS_PER_PAGE_OF_USERS_ACTIVITY_LOG:
      return Object.assign({}, state, payload);

    case actionTypes.UPDATE_CURRENT_PAGE_OF_USERS_SEND_NOTIFICATION:
      return Object.assign({}, state, payload);

    case actionTypes.UPDATE_ROWS_PER_PAGE_OF_USERS_SEND_NOTIFICATION:
      return Object.assign({}, state, payload);

    default:
      return state;
  }
}
